import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-base-panel-card',
    templateUrl: './base-panel-card.component.html',
    styleUrls: ['./base-panel-card.component.scss'],
    standalone: false
})
export class BasePanelCardComponent {
  @Input() headingText!: string;
}
